import styled from 'styled-components';

export const Wrapper = styled.div`
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    z-index: 115;
    background: rgba(51, 51, 51, 0.35);
    box-sizing: border-box;
    display: flex;
    overflow: hidden;
    overflow-y: scroll;
    display: ${(props) => (props.talkToUsIsOpen ? 'block' : 'none')};
`;

export const ModalWrapper = styled.div`
    width: 100%;
    padding: 0.8rem;
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    @media (max-width: 500px) {
        position: relative;
        padding: 0;
        height: 100%;
        position: static;
    }
`;

export const Modal = styled.div`
    width: 360px;
    min-height: 583px;
    max-width: 100%;
    position: relative;
    top: 50%;
    margin: 0 auto;
    background: #fff;
    padding: 3px;
    box-sizing: border-box;
    border-radius: 5px;
    @media (max-width: 500px) {
        width: 100%;
    }
`;

export const Heading = styled.div`
    background: #00b357;
    color: #fff;
    font-size: 24px;
    padding: 0.6rem 1rem;
    text-transform: uppercase;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    > svg {
        width: 28px;
        height: 28px;
        margin-bottom: 5px;
    }
`;

export const HeadTextWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const SubHeading = styled.div`
    padding: 0.7rem 0.5rem;
    font-size: 14px;
    color: #000;
    box-sizing: border-box;
`;

export const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0.7rem 0.5rem;
    padding-top: 0;
    box-sizing: border-box;
    position: relative;
    input {
        padding: 0.7rem 0.5rem;
        border: 1px solid ${(props) => (props.error ? '#F2858D' : '#cbcbcb')};
        height: 48px;
        box-sizing: border-box;
        font-size: 20px;
    }
`;

export const Input = styled.input`
    padding: 0.7rem 0.5rem;
    border-radius: 3px;
    font-size: 20px;
    font-family: Montserrat;
    outline: none;

    &:focus {
        border-color: #777;
    }
`;

export const Label = styled.label`
    font-weight: 600;
    color: #70757a;
    font-size: 18px;
    letter-spacing: 0.72px;
    margin-bottom: 7px;
`;
export const Control = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.7rem 0.5rem;
    border-radius: 3px;
    border: 1px solid ${(props) => (props.error ? '#F2858D' : '#cbcbcb')};
    outline: none;
    color: #4f4f4f;
    cursor: pointer;
    height: 48px;
    box-sizing: border-box;
    &:focus {
        border-color: #777;
    }
`;
export const ValueContainer = styled.div``;
export const Placeholder = styled.div`
    white-space: nowrap;
    overflow: hidden;
    font-size: 20px;
    text-overflow: ellipsis;
    font-family: Montserrat;
`;
export const Indicators = styled.div``;
export const IndicatorContainer = styled.div`
    margin-left: 3px;
`;
export const Menu = styled.div`
    display: ${(props) => (props.isOpen ? 'block' : 'none')};
    position: absolute;
    top: 73px;
    background: #fff;
    border: 1px solid #cbcbcb;
    width: 338px;
    box-sizing: border-box;
    font-size: 16px;
    @media (max-width: 500px) {
        width: 100%;
        position: static;
    }
`;
export const MenuItem = styled.div`
    background: ${(props) => (props.isActive ? '#4A90E2' : 'none')};
    color: ${(props) => (props.isActive ? '#fff' : '#000')};
    cursor: pointer;
    padding: 4px 9px;
`;

export const Actions = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.3rem 0;
    padding-bottom: 1rem;
`;

export const SubmitButton = styled.button`
    font-family: Montserrat;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 18px;
    text-align: center;
    text-transform: uppercase;
    color: #00b357;
    background: #fff;
    border: 2px solid #00b357;
    padding: 0.6rem 0;
    width: 180px;
    border-radius: 5px;
    transition: 0.3s;
    &:hover {
        cursor: pointer;
    }
    &:disabled {
        border: 2px solid #828282;
        color: #828282;
        cursor: default;
    }
`;

export const ErrorMessage = styled.div`
    padding: 0.7rem 0.5rem;
    background: #ec4652;
    color: #fff;
    border-radius: 3px;
    margin-bottom: 0.3rem;
`;

export const ErrorText = styled.div`
    margin-top: 3;
    color: rgb(236, 70, 82);
`;

export const InfoMessage = styled.div`
    display: flex;
    flex-direction: column;
    height: 528px;
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
    color: #000;
    box-sizing: border-box;
    padding: 32px 18px 0px 11px;
`;
export const WrapperForIcon = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 18px;
`;
